module.exports = __webpack_public_path__ + "static/media/python.d9c6e4b2.png";